import { createActions, createReducer } from 'reduxsauce';

// One list per user type so the Customers and Businesses tabs don't
// overwrite each other.
const INITIAL_LIST = {
  fetching: false,
  fetched: false,
  error: null,
  data: [],
};

export const INITIAL_STATE = {
  customer: INITIAL_LIST,
  business: INITIAL_LIST,
};

const { Types, Creators } = createActions(
  {
    getNewUsers: ['userType'],
    getNewUsersRequest: ['userType'],
    getNewUsersSuccess: ['userType', 'data'],
    getNewUsersFailure: ['userType', 'error'],
  },
  { prefix: 'cb/admin/userManager/fetchNewUsers' },
);

export { Types as types, Creators as actions };

const listFor = (state, userType) => state[userType] || INITIAL_LIST;

// Keeps the previous rows while refreshing, so the list doesn't flash empty.
const request = (state, { userType }) => ({
  ...state,
  [userType]: { ...listFor(state, userType), fetching: true, error: null },
});

const success = (state, { userType, data }) => ({
  ...state,
  [userType]: { fetching: false, fetched: true, error: null, data: Array.isArray(data) ? data : [] },
});

const failure = (state, { userType, error }) => ({
  ...state,
  [userType]: { ...listFor(state, userType), fetching: false, error },
});

export const HANDLERS = {
  [Types.GET_NEW_USERS_REQUEST]: request,
  [Types.GET_NEW_USERS_SUCCESS]: success,
  [Types.GET_NEW_USERS_FAILURE]: failure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
